import React, { useState, useCallback, useEffect } from "react";
import { Popover, Button, AutoComplete, Row, Col } from "antd";
import { useIntl } from "react-intl";

import AddressTypeSelect from "./addressTypeSelect";
import { error, warn } from "../../../modules/messages";
import { addSuffixToKeys } from "../../../modules/functions";
import { getEntities } from "../../../modules/crudOperations";
import { parseAddress } from "../../../modules/consignmentFunctions";

function AddressSearchInput({
  form,
  domestic,
  countries,
  addressType,
  onChoosenAddress,
}) {
  const intl = useIntl();
  const [addresses, setAddresses] = useState();
  const [selectedType, setSelectedType] = useState();
  const handleLoadAddresses = useCallback(
    (value, type) => {
      getEntities("address", setAddresses, undefined, {
        domestic,
        search: value,
        addressType: type || selectedType || addressType || "ALL",
      });
    },
    [domestic, selectedType, addressType]
  );

  const [currentSearch, setCurrentSearch] = useState();
  const handleSearch = useCallback(
    (value) => {
      if (value && value.length > 1) {
        setCurrentSearch(value);
        handleLoadAddresses(value);
      }
    },
    [handleLoadAddresses]
  );

  const handleTypeChange = useCallback(
    (newType) => {
      currentSearch && handleLoadAddresses(currentSearch, newType);
      setSelectedType(newType);
    },
    [currentSearch, handleLoadAddresses]
  );

  const handleSelect = useCallback(
    (value) => {
      const numberValue = parseInt(value);
      if (addresses && addresses !== "e" && addresses.find) {
        const chosenAddress = addresses.find((a) => a.id === numberValue);
        if (chosenAddress) {
          if (
            !countries ||
            countries.some((c) => c.id === chosenAddress.countryId)
          ) {
            const formValues = {
              name: { value: chosenAddress.name },
              subname: { value: chosenAddress.subname },
              street: { value: chosenAddress.street },
              streetNumber: { value: chosenAddress.streetNumber },
              localDestination: { value: chosenAddress.localDestination },
              city: { value: chosenAddress.city },
              zipCode: { value: chosenAddress.zipCode },
              countryId: { value: chosenAddress.countryId },
              contactPerson: { value: chosenAddress.contactPerson },
              preselectionId: { value: chosenAddress.preselectionId },
              contactPhone: { value: chosenAddress.contactPhone },
              contactEmail: { value: chosenAddress.contactEmail },
            };
            onChoosenAddress && onChoosenAddress(chosenAddress);
            form.setFields(
              addressType
                ? addSuffixToKeys(formValues, addressType)
                : formValues
            );
          } else {
            warn(
              intl.formatMessage({
                id: "address.searchError",
                defaultMessage:
                  "Vybranou adresu nelze použít z důvodu nepodporovaného státu pro vybraný produkt!",
              })
            );
          }
        }
      }
    },
    [form, intl, addressType, countries, addresses, onChoosenAddress]
  );

  const [dataSource, setDataSource] = useState();
  useEffect(() => {
    if (addresses) {
      addresses !== "e"
        ? setDataSource(
            addresses.map((a) => ({ value: a.id, text: parseAddress(a) }))
          )
        : error(
            intl.formatMessage({
              id: "address.loadError",
              defaultMessage: "Při načítání adres nastala chyba!",
            })
          );
    }
  }, [intl, addresses]);

  return (
    <Row gutter={[0, 10]}>
      <Col>
        <AddressTypeSelect type={addressType} onSetValue={handleTypeChange} />
      </Col>
      <Col>
        <AutoComplete
          autoFocus
          allowClear
          dataSource={dataSource}
          onSelect={handleSelect}
          onSearch={handleSearch}
          className="address-search-input"
          placeholder={intl.formatMessage({
            id: "address.searchInfo",
            defaultMessage: "zadejte název, ulici, město, kontakt..",
          })}
        />
      </Col>
    </Row>
  );
}

const AddressSearch = ({
  form,
  domestic,
  noColumns,
  countries,
  addressType,
  onChoosenAddress,
}) => {
  const intl = useIntl();
  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      title={intl.formatMessage({
        id: "address.search",
        defaultMessage: "Vyhledávání adres",
      })}
      content={
        <AddressSearchInput
          form={form}
          domestic={domestic}
          countries={countries}
          addressType={addressType}
          onChoosenAddress={onChoosenAddress}
        />
      }
    >
      <Button
        icon="search"
        type="primary"
        shape="circle"
        className={`address-search-button${noColumns ? "-special" : ""}`}
      />
    </Popover>
  );
};

export default AddressSearch;
